import VueRouter, { RouteConfig } from 'vue-router'

const Index = () => import('../activity/202402/exchange-reward-score/index.vue')
const Rank = () => import('../activity/202402/exchange-reward-score/Rank/Rank.vue')
const Record = () => import('../activity/202402/exchange-reward-score/RecordList.vue')

export const indexRoute: RouteConfig = {
  path: '/exchange-reward-score-2024',
  name: 'exchange_reward_score_2024',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '积分兑换',
    ignoreLogin: true,
  },
}

export const recordRoute: RouteConfig = {
  path: '/exchange-reward-score-2024-record',
  name: 'exchange_reward_score_2024_record',
  component: Record,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '积分兑换',
    ignoreLogin: true,
  },
}

export const rankRoute: RouteConfig = {
  path: '/exchange-reward-score-2024-rank',
  name: 'exchange_reward_score_2024_rank',
  component: Rank,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '积分兑换',
    ignoreLogin: true,
  },
}

export default [indexRoute, rankRoute, recordRoute]

export function navigateToExchangeReward2024(router: VueRouter) {
  router.push({ name: indexRoute.name })
}
